import { msSessionId, platformCookieValueWebView } from '@onyx/constants';
import { getCookie, isWebView, setEssentialCookie } from '@onyx/cookies';
import type { NextApiRequest, NextApiResponse } from 'next/types';

type TelemetryCtx = {
  req: NextApiRequest;
  res: NextApiResponse;
};

const getFirstHeaderValue = (
  res: NextApiResponse,
  header: string
): string | undefined => {
  const value = res.getHeader(header);
  if (typeof value === 'string') {
    return value;
  }
  if (Array.isArray(value) && value.length > 0) {
    return value[0];
  }
  return undefined;
};

export const getTelemetrySessionId = ({
  ctx,
}: {
  ctx?: TelemetryCtx;
} = {}): string => {
  const sessionId =
    getCookie(msSessionId, { ctx }) ??
    (ctx && getFirstHeaderValue(ctx.res, msSessionId));

  if (sessionId) {
    return sessionId;
  }

  const hasCrypto = typeof crypto !== 'undefined' && crypto.randomUUID;

  if (hasCrypto) {
    const guid = crypto.randomUUID();
    setEssentialCookie(msSessionId, guid, { ctx, path: '/' });
    ctx && ctx.res.setHeader(msSessionId, guid);
    return guid;
  }
  return 'unknown-user';
};

const getTelemetryPlatform = (ctx?: TelemetryCtx): string => {
  if (ctx || typeof window === 'undefined') {
    return 'server';
  }

  return isWebView(ctx) ? platformCookieValueWebView : 'web';
};

export const getTelemetryBaggage = ({
  ctx,
}: { ctx?: TelemetryCtx } = {}): string => {
  const telemetrySessionId = getTelemetrySessionId({ ctx });
  const telemetryPlatform = getTelemetryPlatform(ctx);

  return `MS-SESSION-ID=${telemetrySessionId},MS-PLATFORM=${telemetryPlatform}`;
};
